exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btns {\r\n    text-align: center;\r\n    margin-top: 20px;\n}\r\n", ""]);

// exports
